import { IncomeModel, IncomeOptionsDTO, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends BusinessFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
  startAge: number | null;
  endAge: number | null;
}

export interface BusinessFormValues {
  associatedAssetId: string;
  amount: number | null;
  incomeGrowth: number | null;
  startYear: number | null | undefined;
  endYear: number | null | undefined;
  selfEmployed: boolean | null;
  endAtRetirement: boolean | null;
  orionManagementStyleId: number | null;
  customBucketIndex: number | null;
}

const defaultFormValues = {
  associatedAssetId: '',
  amount: null,
  incomeGrowth: null,
  startYear: undefined,
  endYear: undefined,
  selfEmployed: false,
  endAtRetirement: false,
  orionManagementStyleId: null,
  customBucketIndex: null,
};

export const dataToForm = (
  income: IncomeModel | null,
  options: IncomeOptionsDTO,
): BusinessFormValues => {
  if (!income) {
    return defaultFormValues;
  }

  return {
    associatedAssetId: income.AssociatedAssetId,
    amount: income.Amount,
    incomeGrowth: income.IncomeGrowth,
    startYear: income.StartAge,
    endYear: income.EndAtRetirement ? null : income.EndAge ? income.EndAge : undefined,
    selfEmployed: income.SelfEmployed,
    endAtRetirement: income.EndAtRetirement,
    orionManagementStyleId: income.OrionManagementStyleId,
    customBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};
